var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.context.request.country.is_russia &&
    !_setup.context.request.user.is_authenticated
    ? _c("div", { staticClass: "d-flex justify-end align-center" }, [
        _c(
          "a",
          {
            staticClass:
              "text-body-1 text-secondary--text text-decoration-none mr-8",
            attrs: { target: "_blank", href: _setup.siteNameExpert },
          },
          [_vm._v("\n    " + _vm._s(_setup.translate("Клиникам")) + "\n  ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass:
              "text-body-1 text-secondary--text text-decoration-none",
            attrs: {
              target: "_blank",
              href: `${_setup.siteNameExpert}vrachu/`,
            },
          },
          [_vm._v("\n    " + _vm._s(_setup.translate("Врачам")) + "\n  ")]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }